import TableRestoreFiles from '../../../components/table/files/TableRestoreFiles'

function RestoreDocumentPage() {
  return <TableRestoreFiles />
}

export default RestoreDocumentPage
